import { UserGridColumnOverridesMap } from '@ddv/data-grid';
import { AppWidgetState, WidgetPosition } from '@ddv/models';

export class WidgetOnBoard {
    id: number;
    height: number;
    width: number;
    left: number;
    top: number;
    isMaster?: boolean;
    maximized?: boolean;
    widgetPosition?: WidgetPosition;
    widget?: AppWidgetState & { userGridColumnOverrides?: UserGridColumnOverridesMap };
    filters?: string;
    userGridColumnOverrides?: UserGridColumnOverridesMap;

    constructor(init?: Partial<WidgetOnBoard>) {
        this.id = init?.id ?? Number.MIN_VALUE;
        this.height = init?.height ?? 0;
        this.width = init?.width ?? 0;
        this.left = init?.left ?? 0;
        this.top = init?.top ?? 0;
        this.isMaster = init?.isMaster;
        this.maximized = init?.maximized;
        this.widgetPosition = init?.widgetPosition;
        this.filters = init?.filters;
        this.userGridColumnOverrides = init?.userGridColumnOverrides ?? {};

        this.widget = new AppWidgetState(init?.widget);

        this.widget.height = this.height;
        this.widget.width = this.width;
        this.widget.left = this.left;
        this.widget.top = this.top;
        this.widget.widgetPosition = this.widgetPosition;
        this.widget.id = this.id;
        this.widget.isMaster = this.isMaster;
        this.widget.userGridColumnOverrides = this.userGridColumnOverrides;

        if (!this.widget.isSubscribedToDashboardFilters && this.filters) {
            this.applyFilters();
        }
    }

    private applyFilters(): void {
        if (!this.widget?.widgetFilters) {
            return;
        }

        const filters = JSON.parse(this.filters ?? '');

        // this results in the type on this.widget.widgetFilters.funds being a lie
        // it should be Fund[] and it ends up just a POJSO
        if (filters.funds) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.widget.widgetFilters.funds = filters.funds.map((fund: any) => ({
                fundId: fund.fundId,
                fundName: fund.fundName,
                checked: true,
            }));
        }

        // this results in the type on this.widget.widgetFilters.clients being a lie
        // it should be Client[] and it ends up just a POJSO
        if (filters.clients) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.widget.widgetFilters.clients = filters.clients.map((client: any) => ({
                clientId: client.clientId,
                clientName: client.clientName,
                checked: true,
            }));
        }

        if (filters.startDate || filters.endDate) {
            this.widget.widgetFilters.startDate = filters.startDate;
            this.widget.widgetFilters.endDate = filters.endDate;
        }

        this.widget.widgetFilters.activeDate = filters.activeDate;

        if (filters.filters) {
            this.widget.widgetFilters.filters = filters.filters;
        }
    }
}
